export default class Subject {
  constructor (data) {
    if (!data || !data.id) throw new Error('Wrong Subject data')

    this.id = data.id
    this.label = data.name ?? ''
    this.code = data.code ?? 'math'
  }
}
